// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FromUs_wrapper__3-5tC"};